import createDebug from "debug";
createDebug.formatters.h = v => {
    return v.toString("hex");
};
export const debug = createDebug("@@b3dotfun/sdk");
const debugMakers = {};
export const debugB3React = (name) => {
    if (!debugMakers[name]) {
        debugMakers[name] = debug.extend(name);
    }
    return debugMakers[name];
};
export default debug;
